import { addOutBoundToATag } from "src/module/outbound";
import Kzs, { precedingJsContext } from "src/module/kzs";
const kzs: Kzs = window.kzs;

const expScript = (context: precedingJsContext): Promise<void> => {
  kzs.console.log(context);
  // const $ = kzs.$;
  const Promise = kzs.Promise;

  return Promise.resolve().then(() => {
    const elements = addOutBoundToATag(
      new RegExp("https://www1.loan-alliance.com/BtWebp")
    );
    kzs.console.log("Outbounded", elements);
  });
};

export default expScript;
